export default __webpack_public_path__ + "assets/Picture12.png";